export default (theme) => ({
    datePickerContainer: {
        position: "fixed",
        top: 0,
        zIndex: "1400",
        width: "100%"
    },
    datePickerStyle: {
        border: "none",
        borderBottom: "1px solid",
        fontSize: "1em",
        padding: "5px 3px",
        width: "100%"
    },
    avatarContainer: {
        width: `${theme.spacing(5)} !important`,
        height: `${theme.spacing(5)} !important`,
        /** Set styles if default and has text */
        "& > div > div, .MuiAvatar-colorDefault ": {
            background: theme.palette.primary.main,
            textTransform: "capitalize",
            color: theme.palette.common.white,
            margin: "-2px"
        }
    },
    chipContainer: {
        textTransform: "capitalize",
        /** Remove margin for Avatar */
        " & > .MuiChip-avatar": {
            marginLeft: 0
        }
    },
    rightNavigation: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& > *": {
            margin: theme.spacing(1),
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main
        }
    },
    userMenuPaper: {
        "& .MuiMenu-paper": {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            marginTop: theme.spacing(1),
            "& .MuiAvatar-root": {
                width: theme.spacing(4),
                height: theme.spacing(4)
            },
            "& ul li > div": {
                marginRight: theme.spacing(1)
            },
            "& ul li:hover svg, & ul li:hover ": {
                color: theme.palette.primary.main
            }
        }
    }
});
